import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { storage } from '@/lib/storage';
import ProposalRenderer from '@/components/proposal/ProposalRenderer';
import XperienceLogo from '@/components/ui/XperienceLogo';

/**
 * Vista pública de la propuesta — el cliente accede vía /p/:token
 * sin necesitar login.
 *
 * TODO Alejandro:
 * - Validar que el token no esté expirado (public_token_expires_at)
 * - Registrar evento 'vista_publica' en quote_events
 * - Cuando se conecte TRATO+Digid, redirigir el "Aceptar" hacia el flujo de firma
 */
export default function PublicProposal() {
  const { token } = useParams();
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const q = await storage.getQuoteByPublicToken(token);
        if (!q) {
          setError('Esta propuesta no existe o el enlace ha expirado.');
        } else {
          setQuote(q);
        }
      } catch (e) {
        setError(e.message || 'Error al cargar la propuesta');
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const handleAccept = async (aceptacion) => {
    if (!quote) return;
    const updated = {
      ...quote,
      estatus: 'aceptada',
      aceptacion,
    };
    await storage.saveQuote(updated);
    setQuote(updated);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <XperienceLogo className="w-12 h-12 mx-auto mb-4 animate-pulse" />
          <div className="text-neutral-500 text-sm">Cargando propuesta...</div>
        </div>
      </div>
    );
  }

  if (error || !quote) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <XperienceLogo className="w-12 h-12 mx-auto mb-6 opacity-50" />
          <h1 className="text-xl font-bold text-white mb-3">
            Propuesta no disponible
          </h1>
          <p className="text-neutral-400 text-sm mb-6">
            {error || 'Este enlace ya no es válido.'}
          </p>
          <p className="text-neutral-500 text-xs">
            Si necesitas ayuda contacta a contacto@xperience.group
          </p>
        </div>
      </div>
    );
  }

  return <ProposalRenderer quote={quote} onAccept={handleAccept} allowAccept={true} />;
}
